
let USER_SERVICE = `/components/api/v1/userservice/user`;
let AUTH_SERVICE = `/auth`;

const APPS = { DOCURATED: "Docurated", ADMIN: "Admin", WORKSPACE: "Workspace" };

const LICENSE_TYPE = {
    AUTHOR: "author",
    DOCURATED: "docurated"
};

const ERROR_MESSGE_ELEMENT_ID = "errorMessage";

let IS_DEV = false;

/**
 * Based on environment dev/prod set the API urls default prod enviornment is set
 */
const setApiUrls = () => {
    const _host = document.location.host;
    // dev enviornment will contain : (port) in host url
    if (_host.split(":").length > 1) {
        IS_DEV = true;
        const _hostName = document.location.hostname;
        USER_SERVICE = `http://${_hostName}:7000${USER_SERVICE}`
        AUTH_SERVICE = `http://${_hostName}:31900${AUTH_SERVICE}`
    }
};

/**
 * Show error message if not authorized
 */
const showError = () => {
    // show the error div
    const errorDiv = document.getElementById(ERROR_MESSGE_ELEMENT_ID);
    errorDiv.style.display = "flex";
}

/**
 * Get access token
 * Assuming refresh token is available, request for access token which will set pwt cookie
 * If refresh token is absent or invalid OR any other error getting/validating tokens, resolve with error.
 */
const getToken = function () {
    return new Promise((resolve, reject) => {
        fetch(`${AUTH_SERVICE}/accessToken`,
            { method: 'GET', credentials: 'include' })
            .then((response) => {
                if (response.status === 200) {
                    response.json()
                        .then(function (data) {
                            resolve(data);
                        }).catch((err) => {
                            throw err;
                        });
                } else {
                    reject(response);
                }
            }, (error) => {
                reject(error);
            }).catch((err) => {
                throw err;
            });
    });
}

/**
 * Get current logged in user details
 */
const getUser = function () {
    return new Promise((resolve, reject) => {
        fetch(`${USER_SERVICE}/whoami`,
            { method: 'GET', credentials: 'include' })
            .then((response) => {
                if (response.status === 200) {
                    response.json()
                        .then(function (data) {
                            resolve(data);
                        }).catch((err) => {
                            throw err;
                        });
                } else {
                    reject(response);
                }
            }, (error) => {
                reject(error);
            }).catch((err) => {
                throw err;
            });
    });
}

/**
 * Redirect to an app accessible to the user based on its license.
 * @param {*} user Current user's login details.
 */
const checkLicenseAndRedirect = (user) => {
    if (user.licenseType || user.id === 1) {    // Allow Admin user even without license
        fetch(`${USER_SERVICE}/accessibleapps`, { method: 'GET', credentials: 'include' })
            .then(apiResp => {
                apiResp.json().then((response) => {
                    const _apps = response;
                    let _appUrl = "";
                    if (user.licenseType === LICENSE_TYPE.DOCURATED) {
                        const _app = _apps.find((_app) => _app.appName === APPS.DOCURATED);
                        if (_app && _app.isAccessible) {
                            _appUrl = _app.url;
                        }
                    } else {
                        const _app = _apps.find((_app) => _app.appName === APPS.WORKSPACE);
                        // if target app is accessible then redirect
                        if (_app) {
                            _appUrl = _app.url;
                        }
                    }
                    if (_appUrl) {
                        document.location.href = _appUrl;
                    } else {
                        showError();
                    }
                }).catch((err) => {
                    throw err;
                });
            }).catch((err) => {
                throw err;
            });
    } else {
        // Current user has no CE license assigned
        showError();
    }
};

// init the app 
const init = () => {
    setApiUrls();
    getToken()
        .then(getUser)
        .then(checkLicenseAndRedirect)
        .catch(
            // Some error getting token or user or apps info.
            // Force login by redirecting to auth
            function (_err) {
                console.debug(document.location.href);
                // in case of offline token will fail
                getUser().then(checkLicenseAndRedirect).catch(
                    function (__err) {
                        const currentUrl = document.location.href;
                        console.debug(currentUrl);
                        document.location.href = `${AUTH_SERVICE}/platform?_r=${currentUrl}`;
                    });
            });
}

init();